"use client";

import { tGlob } from "@/app/[lang]/_t-glob/t-glob";
import { createT } from "@/app/[lang]/_utils/create-t";
import Image from "@/components/Image";
import { env } from "@/env";
import type { Lang } from "@/langs";
import { api } from "@/trpc/react";
import { Card } from "@borderless/ui/components/card";
import { useCollegeColor } from "@borderless/ui/hooks/use-college-color";
import { type FC } from "react";
import dictionary from "./t.json";

const t = createT(dictionary);

export const AidPromo: FC<{
  lang: Lang;
}> = (props) => {
  return null;

  // const { data, isPending, isError } = api.user.findSelf.useQuery();

  // // if (
  // //   !isPending &&
  // //   !isError &&
  // //   data !== null &&
  // //   data.completedOnboardingAt !== null
  // // ) {
  // //   // already using app
  // //   return null;
  // // }

  // return (
  //   <Link
  //     href="/app"
  //     className="not-prose relative my-4 block overflow-hidden rounded-xl bg-purple-200 px-4 py-8 hover:opacity-80 md:my-6"
  //     style={{
  //       backgroundImage:
  //         "radial-gradient(circle at top left, #F28BAE 0%, transparent 30%), radial-gradient(circle at bottom right, #BA68FA 0%, transparent 30%)",
  //     }}
  //   >
  //     <
  //       width="7rem"
  //       className="absolute -bottom-8 -left-6 rotate-[200deg]"
  //     />
  //     <div>
  //       <AidIcon
  //         width="5rem"
  //         className="absolute right-0 -bottom-2 -rotate-12 bg-transparent"
  //       />
  //     </div>

  //     <p className="relative text-center text-lg font-semibold text-balance text-indigo-800">
  //       {t(
  //         "Want to get a full scholarship to your dream university?",
  //         props.lang,
  //       )}
  //       <br />
  //       {t(
  //         "Maximize your chances with <underline>Guidance</underline>",
  //         props.lang,
  //       )}
  //     </p>
  //   </Link>
  // );
};

export const UniversityPromo: FC<{
  lang: Lang;
  universityName: string;
  universityLogoImageUrl: string;
  logoColorC: number;
  logoColorH: number | null;
}> = ({ universityName, universityLogoImageUrl, ...props }) => {
  const { data, isPending, isError } = api.user.findSelf.useQuery();

  const { bgColor, shadowColor, foregroundColor, foregroundSubtleColor } =
    useCollegeColor({
      org: {
        logoColorC: props.logoColorC,
        logoColorH: props.logoColorH,
      },
    });

  if (
    !isPending &&
    !isError &&
    data !== null &&
    data.completedOnboardingAt !== null
  ) {
    // already using app
    return null;
  }

  return (
    <div
      style={
        {
          "--university-card-bg-color": bgColor,
          "--university-card-shadow-color": shadowColor,
          "--foreground": foregroundColor,
          "--subtle": foregroundSubtleColor,
        } as React.CSSProperties
      }
    >
      <Card
        variant="button"
        className="relative my-4 flex flex-col items-center justify-center gap-6 overflow-hidden bg-(--university-card-bg-color) text-center text-foreground shadow-[4px_4px_0_var(--university-card-shadow-color)] transition-all duration-100 ease-out hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[3px_3px_0_var(--university-card-shadow-color)] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none data-[state=active]:translate-x-[4px] data-[state=active]:translate-y-[4px] data-[state=active]:shadow-none sm:flex-row md:my-8"
      >
        <Image
          src={universityLogoImageUrl}
          alt={universityName}
          width={96}
          height={96}
          className="not-prose size-12 shrink-0 rounded-md md:size-24"
        />
        <div className="max-w-fit flex-1 space-y-2">
          <div className="font-(family-name:--font-caprasimo) text-2xl">
            Get into {universityName} with Borderless
          </div>
          <div className="text-sm font-normal">
            {tGlob("Get Started - *it's free!*", props.lang)}
          </div>
        </div>
        <Image
          src={universityLogoImageUrl}
          alt={universityName}
          width={96}
          height={96}
          className="not-prose hidden size-12 shrink-0 md:block md:size-24"
        />
        <a
          href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}
          className="not-prose absolute inset-0"
        />
      </Card>
    </div>
  );
};

export const EssayPromo: FC<{
  lang: Lang;
}> = () => {
  const { data, isPending, isError } = api.user.findSelf.useQuery();

  if (
    !isPending &&
    !isError &&
    data !== null &&
    data.completedOnboardingAt !== null
  ) {
    // already using app
    return null;
  }

  return (
    <Card
      variant="button"
      className="relative my-4 flex flex-col items-center justify-center gap-6 overflow-hidden text-center sm:flex-row md:my-8"
    >
      <Image
        src="/images/in-story/notebook-and-pens.webp"
        alt="Notebook and Pens"
        width={96}
        height={96}
        className="not-prose size-12 shrink-0 md:size-24"
      />
      <div className="max-w-fit flex-1 space-y-2">
        <div className="font-(family-name:--font-caprasimo) text-2xl">
          Ready to take your own essay to the next level?
        </div>
        <div className="text-sm font-normal">
          Get free essay review on Borderless→
        </div>
      </div>
      <Image
        src="/images/in-story/memopad-and-pencil.webp"
        width={96}
        height={96}
        alt="Memopad and Pencil"
        className="not-prose hidden size-12 shrink-0 md:block md:size-24"
      />
      <a
        href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}
        className="not-prose absolute inset-0"
      />
    </Card>
  );
};

export const ExtracurricularPromo: FC<{
  lang: Lang;
}> = (props) => {
  const { data, isPending, isError } = api.user.findSelf.useQuery();

  if (
    !isPending &&
    !isError &&
    data !== null &&
    data.completedOnboardingAt !== null
  ) {
    // already using app
    return null;
  }

  return (
    <Card
      variant="button"
      className="relative my-4 flex flex-col items-center justify-center gap-6 overflow-hidden text-center sm:flex-row md:my-8"
    >
      <Image
        src="/images/in-story/computer.webp"
        alt="Computer"
        width={96}
        height={96}
        className="not-prose size-12 shrink-0 md:size-24"
      />
      <div className="max-w-fit flex-1 space-y-2">
        <div className="font-(family-name:--font-caprasimo) text-2xl">
          {"Let’s enhance your extracurricular activities"}
        </div>
        <div className="text-sm font-normal">
          {"Get free activity feedack on Borderless→"}
        </div>
      </div>
      <Image
        src="/images/in-story/corkboard-with-notes.webp"
        width={96}
        height={96}
        alt="Corkboard with Notes"
        className="not-prose hidden size-12 shrink-0 md:block md:size-24"
      />
      <a
        href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}
        className="not-prose absolute inset-0"
      />
    </Card>
  );
};

export const EndOfStoryPromo: FC<{
  lang: Lang;
}> = (props) => {
  const { data, isPending, isError } = api.user.findSelf.useQuery();

  if (
    !isPending &&
    !isError &&
    data !== null &&
    data.completedOnboardingAt !== null
  ) {
    // already using app
    return null;
  }

  return (
    <Card
      variant="button"
      className="relative my-4 flex flex-col items-center justify-center gap-8 overflow-hidden text-center sm:flex-row md:my-8"
    >
      <Image
        src="/images/in-story/graduation-cap.webp"
        alt="Graduation Cap"
        width={96}
        height={96}
        className="not-prose size-12 shrink-0 md:size-24"
      />
      <div className="max-w-fit flex-1 space-y-2">
        <div className="font-(family-name:--font-caprasimo) text-2xl">
          Borderless app helps you get into college
        </div>
        <div className="text-sm font-normal">
          {tGlob("Get Started - *it's free!*", props.lang)}
        </div>
      </div>
      <Image
        src="/images/in-story/stack-of-books.webp"
        width={96}
        height={96}
        alt="Stack of Books"
        className="not-prose hidden size-12 shrink-0 md:block md:size-24"
      />
      <a
        href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}
        className="not-prose absolute inset-0"
      />
    </Card>
  );
};
